import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDatepicker, NgbDateStruct, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { right } from '@popperjs/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../../endpoints/endpoint';
import { NetworkService } from '../../../services/network.service';
import { Utility } from '../../../utility/utility';
import { environment } from '../../../../environments/environment';
import { GenericResponseDto } from '../../gestione-utenti/gestione-utenti.costants';
import { LocalAgreementDto } from './local-agreement-costants';

@Component({
  selector: 'app-local-agreements-view',
  templateUrl: './local-agreements-view.component.html',
  styleUrls: ['./local-agreements-view.component.css']
})
export class LocalAgreementsViewComponent implements OnInit, OnDestroy {

  settings = {
    actions: {
      custom: [
        {
          name: 'deleteAction',
          title: '&nbsp;<i class="far fa-trash-alt" title="delete" style="margin-left:10%;"></i>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: right,
      sort:false
    },
    columns: {
      id: {
        title: 'ID'
      },
      name: {
        title: 'Name'
      },
      startDate: {
        title: 'StartDate',
        compareFunction(direction: any, a: string, b: string) {
          
          const [dayA,monthA, yearA] = a.split('/');
          const dateA = new Date(+yearA, +monthA - 1, +dayA);
          const [dayB,monthB, yearB] = b.split('/');
          const dateB = new Date(+yearB, +monthB - 1, +dayB);
          
          if (dateA < dateB) {
            return -1 * direction;
          }
          if (dateA > dateB) {
            return direction;
          }
          
          return 0;
        }
      },
      expirationDate: {
        title: 'ExpirationDate',
        compareFunction(direction: any, a: string, b: string) {
          const [dayA,monthA, yearA] = a.split('/');
          const dateA = new Date(+yearA, +monthA - 1, +dayA);
          const [dayB,monthB, yearB] = b.split('/');
          const dateB = new Date(+yearB, +monthB - 1, +dayB);
          
          if (dateA < dateB) {
            return -1 * direction;
          }
          if (dateA > dateB) {
            return direction;
          }
          
          return 0;
        }
      },
      globalCustomerName: {
        title: 'Global Customer Name'
      },
      localCustomerId: {
        title: 'Local Customer Id'
      }


    },
    pager:{
      display:false
    }
  };

  listLocalAgreements: any[] = [];
  destroy$ = new Subject<boolean>();
  deleteResponse: GenericResponseDto;
  responseValidAgreement: GenericResponseDto;
  responseSaveAgreement: GenericResponseDto;

  @ViewChild('confirmDeleteAgreement') confirmDeleteAgreementModal: NgbModalRef;
  @ViewChild('addNewAgreement') addNewAgreementModal: NgbModalRef;

  model: NgbDateStruct;
  dataInizio: { day: number, year: number, month: number };
  dataFine: { day: number, year: number, month: number };
  idAgreement: string;
  idAgreementDelete: string;
  nameAgreement: string;
  @ViewChild('dp') dp: NgbDatepicker;

  modalReference: NgbModalRef;
  flagEliminazione: string = "N";



  constructor(public modalService: NgbModal, public networkService: NetworkService,
    public toastr: ToastrManager, public spinner: NgxSpinnerService,
    private router: Router) { }

  ngOnInit(): void {
    this.initializeListAgreement();
  }

  initializeListAgreement() {

    this.spinner.show("sp1");
    let urlUsers: string = environment.basePath + _ENDPOINT.getAllAgreements;
    let data = {
      body: ''
    }
    this.networkService.post(urlUsers, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.listLocalAgreements = JSON.parse(response.body);
            this.spinner.hide("sp1");

          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during Agreements Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }

        }
        else {

          if (response && Array.isArray(response)) {
            this.listLocalAgreements = response;
            this.spinner.hide("sp1");

          } else if (response && response.length && response.length>0) {
            this.spinner.hide("sp1");
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during Agreements Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }

        }





      },
        err => {

          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during Agreements Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);



        });
  }

  onCustomAction(event: any) {
    switch (event.action) {
      case 'deleteAction':
        this.openDeleteModal(event.data);
        break;
    }
  }

  openDeleteModal(elemToDelete: any) {
    this.idAgreementDelete = elemToDelete.id;
    this.flagEliminazione = elemToDelete.flagAssociato;
    let modalRef = this.modalService.open(this.confirmDeleteAgreementModal, { size: 'sm' });
    modalRef.result.then((result) => {
      if (result) {
        this.deleteAgreement(elemToDelete.id);
      } else {
      }
    }, (reason) => {

      /*Leave empty or handle reject*/

    });

  }

  deleteAgreement(id: string) {

    this.spinner.show("sp1");
    let urlDelete: string = environment.basePath + _ENDPOINT.deleteAgreement;
    let data = Utility.createBodyForPostRequest(id, true);
    this.networkService.post(urlDelete, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.deleteResponse = JSON.parse(response.body);
            if (this.deleteResponse && this.deleteResponse.status == 'OK') {

              this.spinner.hide("sp1");
              this.toastr.successToastr('Agreement deleted successfully!', 'Agreement delete result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.initializeListAgreement();


            } else if (this.deleteResponse && this.deleteResponse.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.deleteResponse.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.initializeListAgreement();
            }

          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr("Error during Agreement delete", 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }
        }
        else {

          if (response && response.status) {
            this.deleteResponse = response;
            if (this.deleteResponse && this.deleteResponse.status == 'OK') {

              this.spinner.hide("sp1");
              this.toastr.successToastr('Agreement deleted successfully!', 'Agreement delete result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.initializeListAgreement();


            } else if (this.deleteResponse && this.deleteResponse.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.deleteResponse.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.initializeListAgreement();
            }
          } else if (response && response.length && response.length>0) {
            this.spinner.hide("sp1");
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during Agreement Delete', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }

        }





      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr("Error during Agreement delete", 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);



        });
  }

  openAddModal() {
    this.idAgreement = '';
    this.modalReference = this.modalService.open(this.addNewAgreementModal, { size: 'md' });
    this.modalReference.result.then((result) => {
      if (result) {

      } else {
      }
    }, (reason) => {

      /*Leave empty or handle reject*/

    });

  }

  dateSelectStartDate(event: any) {
    this.dataInizio = event;
  }

  dateSelectExpirationDate(event: any) {
    this.dataFine = event;
  }

  addAgreementDisable(): boolean {
    let result: boolean = false;
    if (!this.dataInizio || !this.dataFine) {
      return true;
    }
    if (!this.dataInizio.day || !this.idAgreement || !this.dataFine.day || !this.nameAgreement) {
      return true;
    }
    return result;
  }

  startDateDisabled(): boolean {
    let result: boolean = false;
    if (!this.dataInizio) {
      return true;
    }
    if (!this.dataInizio.day) {
      return true;
    }
    return result;
  }

  endDateDisabled(): boolean {
    let result: boolean = false;
    if (!this.dataFine) {
      return true;
    }
    if (!this.dataFine.day) {
      return true;
    }
    return result;
  }

  baseValidationLocalAgreementAdd(): boolean {
    let result: boolean = true;
    //controllo che expiration date sia > di start date
    if (this.dataInizio && this.dataFine) {
      if (this.dataFine.year < this.dataInizio.year) {
        this.toastr.errorToastr("Expiration date must be after the start date", 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
        return false;
      } else if (this.dataFine.year == this.dataInizio.year) {
        if (this.dataFine.month < this.dataInizio.month) {
          this.toastr.errorToastr("Expiration date must be after the start date", 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          return false;
        } else if (this.dataFine.month == this.dataInizio.month) {
          if (this.dataFine.day <= this.dataInizio.day) {
            this.toastr.errorToastr("Expiration date must be after the start date", 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            return false;
          }
        }
      }
    }

    return result;
  }

  saveAgreement() {
    if (this.baseValidationLocalAgreementAdd()) {
      this.validaNewAgreementBe();
    }
  }

  insertNewAgreement(input: LocalAgreementDto) {
    this.spinner.show("sp1");
    let urlUsers: string = environment.basePath + _ENDPOINT.saveAgreement;
    let data = Utility.createBodyForPostRequest(input);
    this.networkService.post(urlUsers, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.responseSaveAgreement = JSON.parse(response.body);
            if (this.responseSaveAgreement && this.responseSaveAgreement.status == 'OK') {

              this.spinner.hide("sp1");
              this.toastr.successToastr('Local Agreement added successfully!', 'Agreement added result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.initializeListAgreement();


            } else if (this.responseSaveAgreement && this.responseSaveAgreement.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.responseSaveAgreement.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.initializeListAgreement();
            }


          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during the save agreement', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.initializeListAgreement();
          }
        }
        else {
          if (response && response.status) {
            this.responseSaveAgreement = response;
            if (this.responseSaveAgreement && this.responseSaveAgreement.status == 'OK') {

              this.spinner.hide("sp1");
              this.toastr.successToastr('Local Agreement added successfully!', 'Agreement added result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.initializeListAgreement();


            } else if (this.responseSaveAgreement && this.responseSaveAgreement.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.responseSaveAgreement.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.initializeListAgreement();
            }
          } else if (response && response.length && response.length>0) {
            this.spinner.hide("sp1");
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during the save agreement', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }
        }





      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during the save agreement', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);



        });
  }

  createDataPostInsertAgreement(): LocalAgreementDto {
    let dayInizioString: any = "";
    let monthInizioString: any = "";
    let dayFineString: any = "";
    let monthFineString: any = "";
    if (this.dataInizio && this.dataInizio.day && this.dataInizio.day.toString().length == 1) {
      dayInizioString = "0" + this.dataInizio.day;
    } else {
      dayInizioString = this.dataInizio.day;
    }
    if (this.dataInizio && this.dataInizio.month && this.dataInizio.month.toString().length == 1) {
      monthInizioString = "0" + this.dataInizio.month;
    } else {
      monthInizioString = this.dataInizio.month;
    }
    if (this.dataFine && this.dataFine.day && this.dataFine.day.toString().length == 1) {
      dayFineString = "0" + this.dataFine.day;
    } else {
      dayFineString = this.dataFine.day;
    }
    if (this.dataFine && this.dataFine.month && this.dataFine.month.toString().length == 1) {
      monthFineString = "0" + this.dataFine.month;
    } else {
      monthFineString = this.dataFine.month;
    }
    let startDate: string = dayInizioString + "/" + monthInizioString + "/" + this.dataInizio.year;
    let endDate: string = dayFineString + "/" + monthFineString + "/" + this.dataFine.year;
    let data: LocalAgreementDto = {
      id: this.idAgreement,
      startDate: startDate,
      expirationDate: endDate,
      name: this.nameAgreement
    }
    return data;
  }

  validaNewAgreementBe() {

    this.spinner.show("sp1");
    let urlUsers: string = environment.basePath + _ENDPOINT.validationNewAgreement;
    let input: LocalAgreementDto = this.createDataPostInsertAgreement();
    let data = Utility.createBodyForPostRequest(input);
    this.networkService.post(urlUsers, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.responseValidAgreement = JSON.parse(response.body);
            if (this.responseValidAgreement && this.responseValidAgreement.status == 'OK') {

              this.spinner.hide("sp1");
              this.modalReference.close(true);
              this.insertNewAgreement(input);



            } else if (this.responseValidAgreement && this.responseValidAgreement.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.responseValidAgreement.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

            }


          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during the save validation', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }
        }
        else {
          if (response && response.status) {
            this.responseValidAgreement = response;
            if (this.responseValidAgreement && this.responseValidAgreement.status == 'OK') {

              this.spinner.hide("sp1");
              this.modalReference.close(true);
              this.insertNewAgreement(input);



            } else if (this.responseValidAgreement && this.responseValidAgreement.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.responseValidAgreement.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

            }
          } else if (response && response.length && response.length>0) {
            this.spinner.hide("sp1");
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during the save validation', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });

          }
        }





      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during the save validation', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);



        });
  }

  deleteAgreementDisable() {
    if (this.flagEliminazione == "Y") {
      return true;
    } else {
      return false;
    }
  }

  



  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }



}
